import React from "react";
import { SavedRow, } from "./types";
import { PropertyAPI } from "./lib/property-api";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
//import properties from "./properties.json";
import { PropertyImage } from "./types";
import { dd, toS3Image } from "./Utils";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { PropertySource } from "./lib/property-api";
import { get_source } from "./lib/source";
interface ImageGalleryEntry {
  original: string;
  thumbnail: string;
  order?: number;
}

interface Props {
  property_id: string;
  source: PropertySource;
}
function FancyImageGallery(props: Props) {
  //const [isStaging, setIsStaging] = React.useState<boolean>(false);
  const [data, setData] = React.useState<SavedRow|null>(null);
  const [propertyID, setPropertyID] = React.useState<string>(props.property_id);
  const [error, setError] = React.useState<string | null>(null);
  const [images, setImages] = React.useState<ImageGalleryEntry[]>([]);
  //const [properties,setProperties] = React.useState<PropertiesFile|null>(null);
  const [api,_] = React.useState<PropertyAPI>(new PropertyAPI());
  React.useEffect(() => {
    (async () => {
      setPropertyID(props.property_id);
      setData(await api.get_property_by_source(props.property_id,get_source()));
      if (!data){
        setError("Unable to find the listing you were looking for.");
      }else{
        setError(null);
      }
    })();
  },[]);

  React.useEffect(() => {
    dd({ propertyID, error });
    //setPhotoCount(properties[key].Media.length);
    let images: ImageGalleryEntry[] = [];
    for (const media of data?.Media ?? []) {
      try {
        let img: PropertyImage = toS3Image(media.MediaURL, media.Order, props.source);
        images.push({
          original: img.src.toString(),
          thumbnail: img.thumb.toString(),
          order: img.order,
        });
      } catch (err) {}
    }
    if (images.length) {
      images.sort(
        (a: ImageGalleryEntry, b: ImageGalleryEntry) => {
          if(a.order !== undefined && b.order !== undefined){
            return a.order - b.order;
          }
          return 0;
        }
      );
      images = images.map((v: ImageGalleryEntry) => {
        return {
          original: v.original,
          thumbnail: v.thumbnail,
        };
      });
      setImages(images);
    }
  }, [props,data,] );
  return (
    <div className="FancyImageGallery container">
      {images.length > 0 && <ImageGallery items={images} />}
    </div>
  );
}

export default FancyImageGallery;
